const ACHIEVEMENTS = {
  FIRST_WIN: {
    id: 'FIRST_WIN',
    name: 'First Victory',
    description: 'Complete your first game',
    icon: '🏆'
  },
  PERFECT_ROUND: {
    id: 'PERFECT_ROUND',
    name: 'Perfect Eye',
    description: 'Guess correctly on first try',
    icon: '👁️'
  },
  STREAK_3: {
    id: 'STREAK_3',
    name: 'Hot Streak',
    description: 'Get 3 correct answers in a row',
    icon: '🔥'
  },
  NO_HINTS: {
    id: 'NO_HINTS',
    name: 'Pure Skill',
    description: 'Win a game without using hints',
    icon: '💪'
  },
  HIGH_SCORE_500: {
    id: 'HIGH_SCORE_500',
    name: 'High Scorer',
    description: 'Score over 500 points in one game',
    icon: '⭐'
  },
  HARD_MODE: {
    id: 'HARD_MODE',
    name: 'Challenge Seeker',
    description: 'Complete a game on hard difficulty',
    icon: '😈'
  },
  COMBO_MASTER: {
    id: 'COMBO_MASTER',
    name: 'Combo Master',
    description: 'Get a 5x combo streak',
    icon: '⚡'
  }
};

export const getUnlockedAchievements = () => {
  const stored = localStorage.getItem('achievements');
  return stored ? JSON.parse(stored) : [];
};

export const unlockAchievement = (achievementId) => {
  const current = getUnlockedAchievements();
  if (!current.includes(achievementId)) {
    const updated = [...current, achievementId];
    localStorage.setItem('achievements', JSON.stringify(updated));
    return ACHIEVEMENTS[achievementId];
  }
  return null;
};

export const checkAchievements = (gameStats) => {
  const newAchievements = [];
  
  // First win
  if (gameStats.gamesPlayed === 1) {
    const achievement = unlockAchievement('FIRST_WIN');
    if (achievement) newAchievements.push(achievement);
  }

  // Perfect round
  if (gameStats.roundScores.some(round => round.guessCount === 1)) {
    const achievement = unlockAchievement('PERFECT_ROUND');
    if (achievement) newAchievements.push(achievement);
  }

  // Streak of 3
  if (gameStats.bestStreak >= 3) {
    const achievement = unlockAchievement('STREAK_3');
    if (achievement) newAchievements.push(achievement);
  }

  // No hints
  if (gameStats.hintsUsed === 0) {
    const achievement = unlockAchievement('NO_HINTS');
    if (achievement) newAchievements.push(achievement);
  }

  // High score
  if (gameStats.totalScore >= 500) {
    const achievement = unlockAchievement('HIGH_SCORE_500');
    if (achievement) newAchievements.push(achievement);
  }

  // Hard mode
  if (gameStats.difficulty === 'Hard') {
    const achievement = unlockAchievement('HARD_MODE');
    if (achievement) newAchievements.push(achievement);
  }

  // Combo achievement
  if (gameStats.maxCombo >= 5) {
    const achievement = unlockAchievement('COMBO_MASTER');
    if (achievement) newAchievements.push(achievement);
  }

  return newAchievements;
};

export { ACHIEVEMENTS }; 